<template>
    <div>
        <div class="mainLoader" v-if="$store.getters.getGLoading">
          <app-loader/>
        </div>
        <router-view/>
    </div>
</template>

<script>
  import AppLoader from "@/components/app-loader";


  import 'vue-select/dist/vue-select.css';
  export default {
    components: { AppLoader },
  }
  </script>

<style scoped>
  *:focus {
    outline: none;
  }
  textarea:focus,
  textarea.form-control:focus,
  input.form-control:focus,
  input[type=text]:focus,
  input[type=password]:focus,
  input[type=email]:focus,
  input[type=number]:focus,
  [type=text].form-control:focus,
  [type=password].form-control:focus,
  [type=email].form-control:focus,
  [type=tel].form-control:focus,
  [contenteditable].form-control:focus {
    box-shadow: inset 0 -1px 0 #ddd;
  }

  </style>
<style lang="scss">
  /* width */
  ::-webkit-scrollbar {
    background-color: transparent;
    width: 0.4em;
    height: 0.4em;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #7A818F;
    opacity: 0.5;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    opacity: 1;
  }
  button:focus{
    outline: none;
  }
  .mainLoader{
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F9F9FB;
  }
  .cg{
    color: #2CB181;
  }
  .co{
    color: #F39220;
  }
  .tbold{
    font-weight: 500;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }
  .fade-enter, .fade-leave-to {
    width: 85%;
    position: absolute;
    opacity: 0;
  }

  .slide-in-down-enter-active, .slide-in-down-leave-active {
    transition: all 50ms;
  }
  .slide-in-down-enter, .slide-in-down-leave-to {
    transform: translateY(-100px);
    opacity: 0;
  }

  .no-select{
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
